import * as Yup from 'yup';
import { ShootingStatus, ShootingType, VirtualTourType } from '../../../domain/types';
import type { UpsertShootingFormModel } from './UpsertShootingForm';
import { NO_VIRTUAL_TOUR } from '../../constants';
import { Shooting } from '../../../providers/api/dtos';

export const upsertShootingValidationSchema = (shooting?: Shooting) => (
  hiddenFields?: Partial<Record<keyof UpsertShootingFormModel, boolean>>,
  disabledFields?: Partial<Record<keyof UpsertShootingFormModel, boolean>>,
) => Yup.object({
  type: (hiddenFields?.type || disabledFields?.type)
    ? Yup.mixed().notRequired()
    : Yup.string().oneOf(Object.values(ShootingType)).required('Il campo è obbligatorio'),
  photographer: (hiddenFields?.photographer || disabledFields?.photographer)
    ? Yup.mixed().notRequired()
    : Yup.object({
      id: Yup.string().default(''),
    }).when('type', {
      is: (type: ShootingType | '') => type === ShootingType.DIRECT,
      then: (schema) => schema.shape({
        id: Yup.string().trim().required('Il campo è obbligatorio'),
      }),
      otherwise: (schema) => schema.shape({
      }),
    }),
  date: (hiddenFields?.date || disabledFields?.date)
    ? Yup.mixed().notRequired()
    : Yup.date().required('Il campo è obbligatorio'),
  time: (hiddenFields?.time || disabledFields?.time)
    ? Yup.mixed().notRequired()
    : Yup.string().required('Il campo è obbligatorio'),
  photoPrice: (hiddenFields?.photoPrice || disabledFields?.photoPrice)
    ? Yup.mixed().notRequired()
    : Yup.number().nullable(),
  extraServicesPrice: (hiddenFields?.extraServicesPrice || disabledFields?.extraServicesPrice)
    ? Yup.mixed().notRequired()
    : Yup.number().nullable(),
  expensesRefund: (hiddenFields?.expensesRefund || disabledFields?.expensesRefund)
    ? Yup.mixed().notRequired()
    : Yup.number().nullable(),
  virtualTourType: (hiddenFields?.virtualTourType || disabledFields?.virtualTourType)
    ? Yup.mixed().notRequired()
    : Yup.string()
      .oneOf([NO_VIRTUAL_TOUR, ...Object.values(VirtualTourType)], 'Il campo è obbligatorio')
      .required('Il campo è obbligatorio'),
  deliveryDate: (hiddenFields?.deliveryDate || disabledFields?.deliveryDate)
    ? Yup.mixed().notRequired()
    : Yup
      .date()
      .when([], {
        is: () => shooting?.projectStatus === ShootingStatus.BOOKED,
        then: (schema) => schema
          .min(Yup.ref('date'), 'La data di consegna deve essere successiva alla data dello shooting')
          .required('Il campo è obbligatorio'),
        otherwise: (schema) => schema.notRequired(),
      }),
  notes: (hiddenFields?.notes || disabledFields?.notes)
    ? Yup.mixed().notRequired()
    : Yup.string(),
});
